import Api from './api';

export async function fetchHighScore(gameMode, type, onSuccess, onError) {
	const url = encodeURI(`high-score/${gameMode}/${type}`);
	try {
		const response = await Api.get(url, {});
		const newHighScoreData = [];
		response.data.map(highScore => newHighScoreData.push({
			id: highScore.id,
			name: highScore.Player.username,
			score: highScore.score,
		}));
		newHighScoreData.slice(0, 10);
		onSuccess([...newHighScoreData]);
	} catch (error) {
		onError(error.message);
	}
}
